module.exports = __webpack_public_path__ + "media/images/ui__arrowRight-fe0b2b39393b703f98e319b9e474d4c6.png";